module.exports = __webpack_public_path__ + "img/documentation.794d6746.svg";